/***
 * This module is used to keep track of data of dynamic components of the page, such as course card/community posts etc etc.
 * These wrappers are always emptied when the page is saved and re-rendered on every page load
 *
 * ***/
import Vue from 'vue';

const initialState = () => { return  {
	componentsData: {}, //holds all componentInfo in the form of {componentId : componentData , .....} / used by renderer factory for cross checking
	componentStates: {},//holds the instance of each class/renderer created for each component { componentId : componentState, .....}
	registeredComponents: [], //keeps track of all components (existing / newly inserted) in the form of { componentId : componentTemplateId, ... }, i.e { "dummyId123" : "tpl49"} / used by the renderer factory
	componentsManagerWrapper : null, //js node that page renderer uses to parse and create components
	componentsManagerInitFlag : false, //js node that page renderer uses to parse and create components
	componentTypesMapping: {
		"blog-post-cards": "BlogPostCards",
		"blog-above-the-fold": "BlogAboveTheFold",
		"blog-post-list": "BlogPostList",
		"bundle-cards": "BundleCards",
		"bundle-purchase": "BundlePurchase",
		"bundle-data": "BundleData",
		"course-cards": "CourseCards",
		"course-contents": "CourseContents",
		"course-enroll": "CourseEnroll",
		"hamburger-menu": "HamburgerMenu",
		"community-post-cards": "CommunityPostCards",
		"daily-news-cards": "DailyNewsCards",
		"filters": "Filters",
		"load-more" : "ActionTrigger",
		"slider-forth-arrow" : "ActionTrigger",
		"slider-back-arrow" : "ActionTrigger",
		"see-all" : "ActionTrigger",
		"navigation-menu" : "NavigationMenu",
		"payment-options": "PaymentOptions",
		"product-checkout" : "ProductCheckout",
		"subscription-cards": "SubscriptionCards",
		"subscription-purchase": "SubscriptionPurchase",
		"user-stats": "UserStats",
		"avatar-image": "Avatar",
		"payment-messages" : "PaymentMessages",
		"payment-product-details" : "PaymentProductDetails",
		"payment-authentication" : "PaymentAuthentication",
		"payment-method": "PaymentMethod",
		"payment-billing-info": "PaymentBillingInfo",
		"copyright": "Copyright",
		"blog-post-filters": "BlogPostFilters",
		"timer": "Timer"
	}, //maps each class with a component type
};
}
export default {
	namespaced : true,
	state : {
		...initialState()
	},
	actions : {
		setComponentsManagerInitFlag ( {commit}, payload) {
			commit('setComponentsManagerInitFlag',payload);
		},
		setComponentsManagerWrapper ( {commit}, payload) {
			commit('setComponentsManagerWrapper',payload);
		},
		setComponentsData ( {commit } , payload) {
			commit('setComponentsData',payload);
		},
		setComponentData ( {commit,state,dispatch}, payload) {
			let componentState = state.componentStates[payload.componentId];

			if (componentState && componentState.hasContext("school-topbar")) {
				dispatch("topbar/setSchoolTopbarComponentData",payload,{root:true});
			} else if (componentState && componentState.hasContext("page-topbar")) {
				dispatch("topbar/setPageTopbarComponentData",payload,{root:true});
			} else if (componentState && componentState.hasContext("schoolFooter")) {
				dispatch("footer/setSchoolFooterComponentData",payload,{root:true});
			} else if (componentState && componentState.hasContext("pageFooter")) {
				dispatch("footer/setPageFooterComponentData", payload, {root: true});
			} else {
				commit('setComponentData', payload);
			}
		},
		addNewComponent ( {commit}, payload) {
			commit('addNewComponent',payload);
		},
		addComponentState ( {commit}, payload) {
			commit('addComponentState',payload);
		},
		registerComponent ( {commit} , payload) {
			commit('registerComponent',payload);
		},
		unregisterComponent ( {commit} , payload) {
			commit('unregisterComponent',payload);
		},
		editRegisteredComponent ( {commit} , payload) {
			commit('editRegisteredComponent',payload);
		},
		initComponentsManager ( {commit} , payload) {
			commit('setComponentsManagerWrapper',payload);
			commit('setComponentsManagerInitFlag',true);
		},
		removeComponentData ({commit,state,dispatch} , payload) {
			let componentState = state.componentStates[payload];

			if (componentState && componentState.hasContext("school-topbar")) {
				dispatch("topbar/removeSchoolTopbarComponent",payload,{root:true});
			} else if (componentState && componentState.hasContext("page-topbar")) {
				dispatch("topbar/removePageTopbarComponent",payload,{root:true});
			}  else if (componentState && componentState.hasContext("schoolFooter")) {
				dispatch("footer/removeSchoolFooterComponent",payload,{root:true});
			}  else if (componentState && componentState.hasContext("pageFooter")) {
				dispatch("footer/removePageFooterComponent",payload,{root:true});
			} else {
				commit('removeComponentData',payload);
			}
		},
		removeComponentState ({commit} , payload) {
			commit('removeComponentState',payload);
		},
	},
	mutations : {
		registerComponent ( state , registrationData) {
			state.registeredComponents.push(registrationData);
		},
		unregisterComponent ( state , componentId) {
			state.registeredComponents.map ( (componentRegistrationData,index) => {
				if (componentRegistrationData.componentId === componentId) {
					Vue.delete(state.registeredComponents,index);
				}
			});
		},
		editRegisteredComponent (state,data) {
			if (data.action === "replaceTempId") {
				state.registeredComponents.map ( (componentRegistrationData,index) => {
					if (data.tempId && componentRegistrationData.tempId === data.tempId) {
						componentRegistrationData.componentId = data.componentId;
						Vue.delete(data,"tempId");
					}
				});
			}
		},
		removeComponentState (state , componentId) {
			if (typeof state.componentStates[componentId] !== "undefined") {
				Vue.delete(state.componentStates,componentId);
			}
		},
		removeComponentData (state , componentId) {
			if (typeof state.componentsData[componentId] !== "undefined") {
				Vue.delete(state.componentsData,componentId);
			}
		},
		setComponentsManagerInitFlag (state,flag) {
			state.componentsManagerInitFlag = flag;
		},
		setComponentsManagerWrapper (state,node) {
			state.componentsManagerWrapper = node;
		},
		clearCurrentPageData (state) {
			const currInitialState = initialState();			
			Object.keys(currInitialState).forEach( key => {
				state[key] = currInitialState[key];
			})
		},
		addNewComponent (state , data) {
			Vue.set(state.componentsData,data.componentId,data);
		},
		setComponentData ( state , data) {

			if (data) {

				if (typeof state.componentsData[data.componentId] === "undefined") {
					Vue.set(state.componentsData,data.componentId,data);
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key) || key === "componentId") {
						continue;
					}

					// if (typeof state.componentsData[data.componentId][key] === "undefined") {
					// 	Vue.set(state.componentsData[data.componentId], key, data[key]);
					// } else {
					// 	state.componentsData[data.componentId][key] = data[key];
					// }
					Vue.set(state.componentsData[data.componentId], key, data[key]);
				}

			}
		},
		addComponentState (state , data) {
			Vue.set(state.componentStates,data.state.componentId,data.state);
			// state.componentStates[componentState.componentId] = componentState;
		},
		setComponentsData ( state, componentsData ) {
			state.componentsData = componentsData  && !Array.isArray(componentsData) ? componentsData : {};
		}
	}
}
